<template>
  <div class="lang-switch">
    <Popover v-model="showPopover" trigger="click" :placement="placement">
      <div class="lang-list">
        <div class="list flex-center-between" :class="item.key == lang ? 'active' : ''" v-for="(item, i) in langArr" :key="i" @click="changeLang(item)">
          {{item.name}}
          <Icon name="success" size="16" v-show="item.key == lang"/>
        </div>
      </div>
      <template #reference>
        <img :src="langUrl" class="lang-icon" alt="">
      </template>
    </Popover>
  </div>
</template>

<script>
import { Icon, Popover } from 'vant'
import { getDefaultLanguage } from '@/utils/common'

export default {
  name: 'LangSwitch',
  components: {
    Icon,
    Popover
  },
  props: {
    placement: {
      type: String,
      default: 'bottom-end'
    }
  },
  data() {
    return {
      langUrl: require('../../assets/imgs/icon-lang.png'),
      showPopover: false,
      lang: '',
      langArr: [
        { name: 'English', key: 'en' },
        { name: 'Русский', key: 'kk' },
        { name: 'Español', key: 'es' },
        { name: 'Français', key: 'fr' },
        { name: 'Deutsch', key: 'de' },
        { name: 'Nederlands', key: 'nl' },
        { name: 'Magyar', key: 'hu' },
        { name: 'Suomi', key: 'fi' },
        { name: 'Norsk', key: 'no' },
        { name: 'Italiano', key: 'it' },
        { name: 'Português', key: 'pt' },
        { name: 'Pусский', key: 'ru' },
        { name: 'Türkçe', key: 'tr' },
        { name: '한국어', key: 'ko' },
        { name: '日本語', key: 'ja' },
        { name: 'Tiếng Việt', key: 'vi' },
        { name: 'Bahasa Indonesia', key: 'id' },
        { name: 'Bahasa Melayu', key: 'ms' },
        { name: 'ภาษาไทย', key: 'th' },
        { name: 'العربية', key: 'ar' },
        { name: 'עברית', key: 'he' },
        { name: 'हिन्दी', key: 'hi' },
        { name: 'Polski', key: 'pl' },
        { name: 'Slovenský', key: 'sk' },
        { name: 'Čeština', key: 'cs' },
        { name: '简体中文', key: 'zh-CN' },
        { name: '繁体中文', key: 'zh-TW' }
      ]
    }
  },
  mounted() {
    const locale = localStorage.getItem('locale')
    const defaultLanguage = getDefaultLanguage()
    this.lang = locale ? locale : defaultLanguage
  },
  methods: {
    changeLang(data) {
      this.lang = data.key
      localStorage.setItem('locale', data.key)
      localStorage.setItem('localeName', data.name)
      this.$i18n.locale = data.key
      this.$store.state.langName = data.name
      this.$store.state.language = data.key
      this.showPopover = false
      window.location.reload()
    }
  }
}
</script>

<style lang="less" scoped>
.lang-switch {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  .lang-icon {
    width: 24px;
    height: 24px;
    display: block;
  }
}
</style>
